import {
  getBettingRulesLinkByCountry,
  getComplaintsLinkByCountry,
  getPrivacyPolicyLinkByCountry,
  getPromotionsLinkByCountry,
  getResponsibleGamblingLinkByCountry,
  getTermsLinkByCountry,
} from '../../international/internationalUtils';

export const links = {
  corporateSiteJobs: (domain: string) => `https://corporate.${domain}.com/jobs/`,
  partnersSite: (domain: string) => `https://partners.${domain}.com`,
  terms: (domain: string) => getTermsLinkByCountry(domain),
  privacyPolicy: (domain: string) => getPrivacyPolicyLinkByCountry(domain),
  complaints: (domain: string) => getComplaintsLinkByCountry(domain),
  bettingRules: (domain: string) => getBettingRulesLinkByCountry(domain),
  promotions: (domain: string) => getPromotionsLinkByCountry(domain),
  surprise: (domain: string) => `https://promo.${domain}.com/surprise`,
  referAFriend: (domain: string) => `https://promo.${domain}.com/refer-a-friend`,
  alpReferAFriend: (domain: string) => `https://promo.${domain}.com/alp-refer-a-friend`,
  responsibleGambling: (domain: string) => getResponsibleGamblingLinkByCountry(domain),
};

export const gamblingLinks = {
  gamstop: 'https://www.gamstop.co.uk',
  gamcare: 'https://www.gamcare.org.uk',
  gamcareUK: 'https://www.gamcare.org.uk/get-support/talk-to-us-now/',
  gambleAware: 'http://begambleaware.org/',
  government: 'https://www.gov.im/categories/business-and-industries/gambling-and-e-gaming/',
  ukLicenceUrl: 'https://www.gamblingcommission.gov.uk/public-register/business/detail/44448',
  finland:
    'https://www.revenue.ie/en/corporate/information-about-revenue/statistics/excise/licences/licensed-remote-bookmaking-operations.aspx',
};

export const DEPOSIT_MIN_AMOUNT_COMPLIANCE_URL =
  'https://kwiff.zendesk.com/hc/en-us/articles/360002360098-What-payment-methods-do-you-offer';
